import { render } from "./StoreOnboardingStepAfterSales.vue?vue&type=template&id=5b8fe6d2"
import script from "./StoreOnboardingStepAfterSales.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepAfterSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__